import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/useLenis";
import { Phone } from "lucide-react";

export default function Nav({ site }) {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 30);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? "bg-ink-900/85 backdrop-blur-md border-b border-white/10" : "bg-transparent"}`}
        >
            <div className="mx-auto max-w-[1400px] px-5 md:px-10 h-[68px] flex items-center justify-between">
                <button
                    onClick={() => scrollToId("top")}
                    data-testid="nav-logo"
                    className="flex items-center gap-3"
                >
                    <img
                        src={site.logo_url}
                        alt={site.business_name}
                        className="h-10 w-10 object-contain"
                    />
                    <div className="hidden sm:block">
                        <div className="font-display text-xl leading-none">{site.business_name.split(" ").slice(0, 3).join(" ")}</div>
                        <div className="font-mono-label text-white/50 mt-0.5">Since Day One · North AL</div>
                    </div>
                </button>

                <nav className="hidden lg:flex items-center gap-8 font-mono-label text-white/70">
                    <button onClick={() => scrollToId("services")} data-testid="nav-services" className="hover:text-lime-signal">01 · Services</button>
                    <button onClick={() => scrollToId("seasons")} data-testid="nav-seasons" className="hover:text-lime-signal">02 · Seasons</button>
                    <button onClick={() => scrollToId("work")} data-testid="nav-work" className="hover:text-lime-signal">03 · Work</button>
                    <button onClick={() => scrollToId("contact")} data-testid="nav-contact" className="hover:text-lime-signal">04 · Contact</button>
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href={`tel:${site.phone_raw || site.phone.replace(/\s+/g, "")}`}
                        data-testid="nav-call"
                        className="hidden md:inline-flex items-center gap-2 font-mono-label text-white/80 hover:text-lime-signal"
                    >
                        <Phone size={14} /> {site.phone}
                    </a>
                    <button
                        onClick={() => scrollToId("contact")}
                        data-testid="nav-quote"
                        className="btn-signal !py-2.5 !px-4 text-sm"
                    >
                        Free Estimate
                    </button>
                    <Link
                        to="/login"
                        data-testid="nav-admin"
                        className="hidden xl:inline-flex font-mono-label text-white/40 hover:text-white/80"
                    >
                        Admin
                    </Link>
                </div>
            </div>
        </header>
    );
}
